import type { JSX } from 'preact';

interface IconProps {
  size?: number;
  className?: string;
  strokeWidth?: number;
  style?: JSX.CSSProperties;
}

function mk(path: JSX.Element) {
  return function Icon({ size = 16, className = '', strokeWidth = 1.5, style }: IconProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width={strokeWidth}
        stroke-linecap="round"
        stroke-linejoin="round"
        class={className}
        style={style}
        aria-hidden="true"
      >
        {path}
      </svg>
    );
  };
}

export const Icons = {
  Triggers: mk(<path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" />),
  Briefing: mk(<g><path d="M4 4h12a4 4 0 014 4v12H8a4 4 0 01-4-4V4z" /><path d="M8 9h8M8 13h8M8 17h5" /></g>),
  Board: mk(<g><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M9 4v16M15 4v16" /></g>),
  Accounts: mk(<g><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" /></g>),
  Coverage: mk(<g><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></g>),
  Activity: mk(<path d="M3 12h4l3-8 4 16 3-8h4" />),
  Contacts: mk(<g><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" /><circle cx="17" cy="10" r="2.5" /><path d="M15 20c0-2.2 1.8-4 4-4" /></g>),
  Personal: mk(<g><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></g>),
  Search: mk(<g><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></g>),
  About: mk(<g><circle cx="12" cy="12" r="9" /><path d="M12 8h.01M11 12h1v4h1" /></g>),
  Bell: mk(<g><path d="M6 8a6 6 0 1112 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10 21a2 2 0 004 0" /></g>),
  Settings: mk(<g><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 00.33 1.82 2 2 0 01-2.83 2.83 1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51 2 2 0 01-4 0 1.65 1.65 0 00-1-1.51 1.65 1.65 0 00-1.82.33 2 2 0 01-2.83-2.83 1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1 2 2 0 010-4 1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82 2 2 0 012.83-2.83 1.65 1.65 0 001.82.33 1.65 1.65 0 001-1.51 2 2 0 014 0 1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33 2 2 0 012.83 2.83 1.65 1.65 0 00-.33 1.82V9c0 .36.13.7.37.94" /></g>),
  Email: mk(<g><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></g>),
  Call: mk(<path d="M5 4h4l2 5-2.5 1.5a11 11 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2" />),
  LinkedIn: mk(<g><rect x="3" y="3" width="18" height="18" rx="3" /><path d="M7 10v7M7 7.5v.01M11 17v-7M11 13c0-2 1-3 2.5-3s2.5 1 2.5 3v4" /></g>),
  InPerson: mk(<g><circle cx="9" cy="7" r="3" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" /><circle cx="17" cy="9" r="2" /><path d="M15 20c0-2.2 1.3-4 3-4s3 1.8 3 4" /></g>),
  Text: mk(<path d="M4 5h16v11H9l-5 4V5z" />),
  Plus: mk(<path d="M12 5v14M5 12h14" />),
  Close: mk(<path d="M6 6l12 12M6 18L18 6" />),
  Check: mk(<path d="M4 12l5 5L20 6" />),
  ArrowRight: mk(<path d="M5 12h14M13 6l6 6-6 6" />),
  ArrowUp: mk(<path d="M12 19V5M6 11l6-6 6 6" />),
  ArrowDown: mk(<path d="M12 5v14M18 13l-6 6-6-6" />),
  Chevron: mk(<path d="M9 6l6 6-6 6" />),
  ChevronDown: mk(<path d="M6 9l6 6 6-6" />),
  Dot: mk(<circle cx="12" cy="12" r="3" fill="currentColor" />),
  MoreH: mk(<g><circle cx="5" cy="12" r="1.5" fill="currentColor" /><circle cx="12" cy="12" r="1.5" fill="currentColor" /><circle cx="19" cy="12" r="1.5" fill="currentColor" /></g>),
  MoreV: mk(<g><circle cx="12" cy="5" r="1.5" fill="currentColor" /><circle cx="12" cy="12" r="1.5" fill="currentColor" /><circle cx="12" cy="19" r="1.5" fill="currentColor" /></g>),
  Filter: mk(<path d="M3 5h18M6 12h12M10 19h4" />),
  Sort: mk(<path d="M4 7h12M4 12h8M4 17h4M18 7v14M18 21l3-3M18 21l-3-3" />),
  Star: mk(<path d="M12 3l2.6 6 6.4.6-4.8 4.4 1.4 6.5L12 17l-5.6 3.5L7.8 14 3 9.6 9.4 9z" />),
  Flag: mk(<path d="M5 21V5m0 0h12l-3 4 3 4H5" />),
  Clock: mk(<g><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></g>),
  Zap: mk(<path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" />),
  Eye: mk(<g><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></g>),
  EyeOff: mk(<g><path d="M3 3l18 18M10.5 10.7a2 2 0 002.8 2.8M9 5.1A10 10 0 0112 5c6.5 0 10 7 10 7a18 18 0 01-3.3 4.4M6.6 6.6A18 18 0 002 12s3.5 7 10 7a10 10 0 005-1.4" /></g>),
  Building: mk(<g><rect x="4" y="3" width="16" height="18" rx="1" /><path d="M9 8h.01M9 12h.01M9 16h.01M15 8h.01M15 12h.01M15 16h.01" /></g>),
  Sparkles: mk(<path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M6 18l2.5-2.5M15.5 8.5L18 6" />),
  Link: mk(<g><path d="M10 14a5 5 0 007 0l3-3a5 5 0 00-7-7l-1 1" /><path d="M14 10a5 5 0 00-7 0l-3 3a5 5 0 007 7l1-1" /></g>),
  Calendar: mk(<g><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18M8 3v4M16 3v4" /></g>),
  FileText: mk(<g><path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z" /><path d="M13 2v7h7M8 13h8M8 17h6" /></g>),
  Target: mk(<g><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1" fill="currentColor" /></g>),
  Refresh: mk(<path d="M21 12a9 9 0 01-15.5 6.3L3 16M3 12a9 9 0 0115.5-6.3L21 8M21 3v5h-5M3 21v-5h5" />),
  ExternalLink: mk(<path d="M14 3h7v7M21 3l-9 9M19 14v5a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h5" />),
  LogOut: mk(<path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />),
};
